export default {
  title: 'Zapłać przez {{method}}',
  hint: 'Dotknij poniższy przycisk i zatwierdź płatność w oknie {{method}}.',
  confirming: 'Potwierdzanie płatności…',
  cancel: 'Anuluj płatność',
  unavailable: 'Ta metoda płatności jest obecnie niedostępna. Wybierz inną.',
  approval_timeout:
    'Nie otrzymaliśmy odpowiedzi od {{method}}. Jeśli okno się nie otworzyło, sprawdź, czy wyskakujące okienka są dozwolone, a następnie spróbuj ponownie lub wybierz inną metodę płatności.',
};
